import { render, staticRenderFns } from "./editFaq.vue?vue&type=template&id=56f821e7&"
import script from "./editFaq.vue?vue&type=script&lang=js&"
export * from "./editFaq.vue?vue&type=script&lang=js&"
import style0 from "./editFaq.vue?vue&type=style&index=0&id=56f821e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports